<script lang="ts">
    import DashboardAdmin from '../framework/components/DashboardAdmin.svelte';
    import AdminDashboardHome from './admin/AdminDashboardHome.svelte';
    import AdminUserList from './admin/AdminUserList.svelte';
    import AdminUserDetail from './admin/AdminUserDetail.svelte';
    import AdminBriefList from './admin/AdminBriefList.svelte';
    import AdminBriefDetail from './admin/AdminBriefDetail.svelte';
import AdminInvoiceList from './admin/AdminInvoiceList.svelte';
import AdminActivityLog from './admin/AdminActivityLog.svelte';
import AdminAiJobs from './admin/AdminAiJobs.svelte';
import AdminTeamList from './admin/AdminTeamList.svelte';
import AdminTeamDetail from './admin/AdminTeamDetail.svelte';
import AdminBilling from './admin/AdminBilling.svelte';
import AdminCreditUsage from './admin/AdminCreditUsage.svelte';
import AdminPlatformKnowledge from './admin/AdminPlatformKnowledge.svelte';
import AdminBriefTypeKnowledgeList from './admin/AdminBriefTypeKnowledgeList.svelte';
import AdminBriefTypeKnowledge from './admin/AdminBriefTypeKnowledge.svelte';
import AdminKnowledgeTest from './admin/AdminKnowledgeTest.svelte';
import BriefQuestionList from "../components/BriefQuestionList.svelte";
    import ProposalRequestList from "./ProposalRequestList.svelte";
    import { auth } from '../framework/js/auth.js';
    import { get } from 'svelte/store';
    import { toast } from "../framework/js/toast.js";

    export let dashboardType = 'Admin';
    let authData: any = {};
    
    auth.subscribe((data: any) => {
        authData = data;
    });

    const logout = async (): Promise<void> => {
        await auth.logout();
        toast.showNotification(get(auth).success, get(auth).message);
        if (get(auth).success) {
            window.location.href = '/#/login';
            window.location.reload();
        }
    };

    interface ComponentDetail {
        component: typeof AdminDashboardHome | typeof AdminUserList | typeof AdminUserDetail | typeof AdminBriefList | typeof AdminBriefDetail | typeof AdminInvoiceList | typeof AdminActivityLog | typeof AdminAiJobs | typeof AdminTeamList | typeof AdminTeamDetail | typeof AdminBilling | typeof AdminCreditUsage | typeof AdminPlatformKnowledge | typeof AdminBriefTypeKnowledgeList | typeof AdminBriefTypeKnowledge | typeof AdminKnowledgeTest | typeof BriefQuestionList | typeof ProposalRequestList | null;
        name: string;
        icon: string;
        href?: string;
        onClick?: () => void;
        className?: string;
        hidden?: boolean;
        group?: string;
    }

    interface Components {
        [key: string]: ComponentDetail;
    }

    const components: Components = {
        'AdminHome': {
            component: AdminDashboardHome,
            name: 'Dashboard',
            icon: 'th icon',
            href: '/dashboard-admin'
        },

        // PEOPLE & TEAMS
        'UserList': {
            component: AdminUserList,
            name: 'Users',
            icon: 'icon user',
            href: '/admin/users',
            group: 'People & Teams'
        },
        'AdminTeamList': {
            component: AdminTeamList,
            name: 'Teams',
            icon: 'icon users',
            href: '/admin/teams',
            group: 'People & Teams'
        },
        'AdminUserDetail': {
            component: AdminUserDetail,
            name: 'User Detail',
            icon: 'icon user',
            href: '/admin/users/',
            hidden: true
        },
        'AdminTeamDetail': {
            component: AdminTeamDetail,
            name: 'Team Detail',
            icon: 'icon users',
            href: '/admin/teams/',
            hidden: true
        },

        // CONTENT & BRIEFS — legacy BtoB admin (questions/versions/list) hidden; knowledge stays under AI & Knowledge
        'AdminBriefList': {
            component: AdminBriefList,
            name: 'All Briefs',
            icon: 'icon file text',
            href: '/admin/briefs',
            group: 'Content & Briefs',
            hidden: true
        },
        'BriefQuestionList': {
            component: BriefQuestionList,
            name: 'BtoB Questions',
            icon: 'icon comment',
            href: '/admin/brief-questions',
            group: 'Content & Briefs',
            hidden: true
        },
        'ProposalRequests': {
            component: ProposalRequestList,
            name: 'Proposal Requests',
            icon: 'icon envelope open outline',
            href: '/admin/proposal-requests',
            group: 'Content & Briefs'
        },
        'AdminBriefDetail': {
            component: AdminBriefDetail,
            name: 'Brief',
            icon: 'icon file text',
            href: '/admin/briefs/',
            hidden: true
        },

        // AI & KNOWLEDGE
        'AdminPlatformKnowledge': {
            component: AdminPlatformKnowledge,
            name: 'AI Knowledge',
            icon: 'icon book',
            href: '/admin/knowledge/platform',
            group: 'AI & Knowledge'
        },
        'AdminAiJobs': {
            component: AdminAiJobs,
            name: 'AI Processes',
            icon: 'icon cogs',
            href: '/admin/ai-processes',
            group: 'AI & Knowledge'
        },

        // BILLING
        'AdminInvoiceList': {
            component: AdminInvoiceList,
            name: 'Invoices',
            icon: 'icon file alternate outline',
            href: '/admin/invoices',
            group: 'Billing'
        },
        'AdminBilling': {
            component: AdminBilling,
            name: 'Billing',
            icon: 'icon credit card outline',
            href: '/admin/billing',
            group: 'Billing'
        },
        'AdminCreditUsage': {
            component: AdminCreditUsage,
            name: 'Credit Usage',
            icon: 'icon coins',
            href: '/admin/credit-usage',
            group: 'Billing'
        },

        // SYSTEM
        'AdminActivityLog': {
            component: AdminActivityLog,
            name: 'Activity Log',
            icon: 'icon history',
            href: '/admin/activity-log',
            group: 'System'
        },
        'AdminBriefTypeKnowledgeList': {
            component: AdminBriefTypeKnowledgeList,
            name: 'Brief-type knowledge',
            icon: 'icon book',
            href: '/admin/knowledge/brief-types',
            hidden: true
        },
        'AdminBriefTypeKnowledge': {
            component: AdminBriefTypeKnowledge,
            name: 'Brief-type knowledge',
            icon: 'icon book',
            href: '/admin/knowledge/brief-types/',
            hidden: true
        },
        'AdminKnowledgeTest': {
            component: AdminKnowledgeTest,
            name: 'Test knowledge',
            icon: 'icon search',
            href: '/admin/knowledge/test',
            hidden: true
        },
        'Logout': {
            component: null,
            name: 'Logout',
            icon: 'icon sign out',
            onClick: logout,
            className: 'item'
        }
    };
</script>

<DashboardAdmin {components} bind:dashboardType={dashboardType} />

